export const USER_ACCESS_TOKEN = 'user-token';
export const USER_REFRESH_TOKEN = 'refresh-token';
export const USER_ID_COOKIE_NAME = 'user-uuid';
export const SESSION_CORRELATION_ID = 'sessions-correlation-id';
export const USER_TEAM = 'user-team';
